define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'underscore', 'jump', 'slider-carousel-infinite-enhanced'],
    function ($, transit, modernizr, container, preloader, _, jumpFactory, sliderCarouselInfiniteEnhancedFactory) {

        return (function () {

            const name = 'module-character';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const carousel = sliderCarouselInfiniteEnhancedFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {
                loadedItems: new Map()
            };

            model.methods = {
                getCharacter: function (id) {

                    if(model.privateVars.loadedItems.has(id)) {
                        pubSub.publish('view/actionShowCharacter', model.privateVars.loadedItems.get(id));
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxCharacterEndpoint + '/' + id,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(id, data);
                            pubSub.publish('view/actionShowCharacter', data);
                        });
                    }
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentCharacter: null,
                anim: 0,
                characterIdArray: [],
                slideStarted: false,

                sliderCount: 0,
                touchStart: 0,
                touchDiff: 0,
                touchStartY: 0,
                touchDiffY: 0,
                endTrans: false,
            };

            view.startup = function () {
                view.privateVars.currentCharacter = parseInt(view.publicVars.currentCharacter);
                view.privateVars.sliderCount = $(view.publicVars.cssId.characterItemCls).length;

                $(view.publicVars.cssId.characterItemCls).each((key, item) => {
                    const id = container.getData(item, 'id');

                    view.privateVars.characterIdArray.push(parseInt(id));
                });
            };

            view.bind = function () {
                $(view.publicVars.cssId.characterItemCls).click(function () {
                    const id = parseInt(container.getData($(this)[0], 'id'));

                    if(view.privateVars.currentCharacter !== id && view.privateVars.anim === 0) {
                        view.privateVars.anim = 1;
                        view.methods.handleCharacterClick(id);
                    }
                });

                $(view.publicVars.cssId.characterId).on('click', view.publicVars.cssId.characterDataArrowLeftId, function () {
                    view.methods.handleArrowClick('left');
                });

                $(view.publicVars.cssId.characterId).on('click', view.publicVars.cssId.characterDataArrowRightId, function () {
                    view.methods.handleArrowClick('right');
                });

                $(view.publicVars.cssId.characterId).bind('touchstart', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseDown(touch);
                });

                $(view.publicVars.cssId.characterId).bind('touchmove', function(e) {
                    /*if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                     e.preventDefault();
                     }*/
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseMove(touch, e);
                });

                $(view.publicVars.cssId.characterId).bind('touchend', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseUp(touch);
                });

                carousel.init(view.publicVars.carouselSetup);
                carousel.setElementDecorateCallback(view.methods.checkCharacterActive);
            };

            view.methods = {

                slideMouseDown: function(e) {

                    if (!view.privateVars.slideStarted && view.privateVars.anim === 0 && view.privateVars.sliderCount > 1)
                    {
                        view.privateVars.touchStart = e.pageX;
                        view.privateVars.touchStartY = e.pageY;

                        view.privateVars.slideStarted = true;

                    }

                    //return false;

                },

                slideMouseMove: function(e, ev) {
                    if (view.privateVars.slideStarted && !view.privateVars.endTrans && view.privateVars.anim === 0)
                    {
                        view.privateVars.touchDiff = view.privateVars.touchStart - e.pageX;
                        view.privateVars.touchDiffY = view.privateVars.touchStartY - e.pageY;

                        if (view.privateVars.touchDiff < -40) {
                            view.methods.handleArrowClick('left');

                        } else if (view.privateVars.touchDiff > 40) {
                            view.methods.handleArrowClick('right');

                        }

                        if (Math.abs(view.privateVars.touchDiff) >= Math.abs(view.privateVars.touchDiffY)) {
                            ev.preventDefault();
                        }
                    }

                    //return false;
                },

                slideMouseUp: function(e) {

                    if (view.privateVars.slideStarted && view.privateVars.anim === 0)
                    {
                        view.privateVars.endTrans = true;
                        if (view.privateVars.touchDiff < -40) {
                            view.methods.handleArrowClick('left');
                        } else if (view.privateVars.touchDiff > 40) {
                            view.methods.handleArrowClick('right');
                        } else {

                            view.privateVars.touchDiff = 0;
                            view.privateVars.touchStart = 0;

                            view.privateVars.touchDiffY = 0;
                            view.privateVars.touchStartY = 0;


                            view.privateVars.slideStarted = false;
                            view.privateVars.endTrans = false;
                        }
                    } else {

                        view.privateVars.slideStarted = false;
                        view.privateVars.endTrans = false;
                    }
                },

                handleArrowClick: (dir) => {

                    let currentIndex = 0;

                    view.privateVars.characterIdArray.forEach((item, key) => {
                        if(view.privateVars.currentCharacter === item) {
                            currentIndex = key;
                        }
                    });

                    if(dir === 'left') {
                        const nextIndex = (currentIndex > 0) ? (currentIndex - 1) : (view.privateVars.characterIdArray.length - 1);

                        if(view.privateVars.anim === 0) {
                            view.privateVars.anim = 1;
                            view.methods.handleCharacterClick(view.privateVars.characterIdArray[nextIndex]);
                        }
                    } else {
                        const nextIndex = (currentIndex < (view.privateVars.characterIdArray.length - 1)) ? (currentIndex + 1) : 0;

                        if(view.privateVars.anim === 0) {
                            view.privateVars.anim = 1;
                            view.methods.handleCharacterClick(view.privateVars.characterIdArray[nextIndex]);
                        }
                    }
                },

                handleCharacterClick: (id) => {
                    $(view.publicVars.cssId.characterItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.characterItemCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    view.privateVars.currentCharacter = parseInt(id);

                    const oldHeight = $(view.publicVars.cssId.characterId).outerHeight();

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 0;
                    }

                    const newWindowHeight = $(window).height() - submenuHeight - headerHeight;

                    let newHeight = oldHeight;
                    let loaderMarginTop = 0;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                        //loaderMarginTop = - (parseInt(headerHeight + submenuHeight) / 2) + 'px';
                    }

                    //console.log(loaderMarginTop);

                    $(view.publicVars.cssId.characterInnerId).transit({opacity: 0}, 300, function () {
                        $(view.publicVars.cssId.characterId).css({ height: newHeight + 'px', minHeight: '0px'});

                        $(view.publicVars.cssId.characterInnerId).html('');

                        $(view.publicVars.cssId.characterId).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                        $(view.publicVars.cssId.characterLoaderId).css({display: 'block', opacity: 0, marginTop: loaderMarginTop});
                        $(view.publicVars.cssId.characterLoaderId).transit({opacity: 1});

                        jump.centerTo(view.publicVars.cssId.characterLoaderId, () => {
                            model.methods.getCharacter(id);
                        }, {
                            modifier: - parseInt(headerHeight + submenuHeight)
                        });
                    });

                    // $(view.publicVars.cssId.characterLoaderId).css({ display: 'block', opacity: 0 });
                    // jump.centerTo(view.publicVars.cssId.characterLoaderId);
                    //
                    // $(view.publicVars.cssId.characterLoaderId).transit({ opacity: 1}, 1200, () => {
                    //
                    //     $(view.publicVars.cssId.characterInnerId).css({ height: newHeight + 'px'});
                    //
                    //     $(view.publicVars.cssId.characterInnerId).html('');
                    //
                    //     //model.methods.getCharacter(id);
                    // });
                },

                checkCharacterActive: (elem) => {
                    const id = container.getData(elem[0], 'id');

                    if (parseInt(id) === view.privateVars.currentCharacter) {
                        $(view.publicVars.cssId.characterItemCls, elem).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else {
                        $(view.publicVars.cssId.characterItemCls, elem).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    }

                    return elem;
                },

                actionShowCharacter: (action, data) => {

                    data.alt = data.nickname.replace(/\"/g, '');

                    container.trackInteraction('show character carousel click', {
                        'subsection': 'series|character',
                        'contenttype': 'character',
                        'contenttitle': data.nickname.toLowerCase().replace(/"/g, "'")
                    });

                    preloader.preloadSingleImage(name, data.item_images[data.id], () => {
                        const compiled = _.template($(view.publicVars.cssId.templateId).html());

                        const output = compiled({
                            data: data
                        });

                        $(view.publicVars.cssId.characterInnerId).html(output);

                        const oldHeight = $(view.publicVars.cssId.characterId).outerHeight();

                        $(view.publicVars.cssId.characterId).removeAttr('style');

                        const newHeight = $(view.publicVars.cssId.characterId).outerHeight();

                        $(view.publicVars.cssId.characterId).css({ height: oldHeight + 'px'});

                        $(view.publicVars.cssId.characterLoaderId).removeAttr('style');

                        $(view.publicVars.cssId.characterId).transit({ height: newHeight + 'px'}, 300, () => {
                            $(view.publicVars.cssId.characterId).removeAttr('style');
                            $(view.publicVars.cssId.characterId).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                            $(view.publicVars.cssId.characterInnerId).transit({opacity: 1}, 300, function () {
                                view.privateVars.anim = 0;
                            });
                        });
                    });
                }

            };

            /* custom events */
            pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
